<script setup>
import AddManualOrderPopup from '@/components/Popups/AddManualOrderPopup.vue';
import { useAuthStore } from '@/stores/authStore';
import { useProductStore } from '@/stores/productsStore';
import { computed } from 'vue';

const authStore = useAuthStore();
const productStore = useProductStore();

</script>

<template>

    <button @click="authStore.toggleAddManualOrderPopup" class="bg-white w-1/2 text-center p-5 rounded-2xl flex gap-5 my-3">
        <span class=" cursor-pointer flex items-center gap-10">
            <i class="pi pi-plus text-purple-500 bg-purple-100 p-4 rounded-full" style="font-size: 1.875rem;"></i>
            <span class="font-semibold">Add Manual Order</span>
        </span>
    </button>
    <AddManualOrderPopup />
</template>

<style scoped>
</style>
